import React from "react";
import { Link } from "react-router-dom";
import "../CSS/UsefulLinks.css";
import heroBg from "../Assets/bgimage.jpg";
import { FaAngleRight, FaLink, FaExternalLinkAlt, FaArrowRight } from "react-icons/fa";
import { MdOutlineLink, MdOutlinePageview } from "react-icons/md";
import { BiLinkExternal } from "react-icons/bi";

export default function UsefulLinks() {
  // Categorized links for better organization
  const linkCategories = [
    {
      title: "Main Pages",
      icon: <MdOutlinePageview />,
      links: [
        { title: "Home", path: "/", description: "Return to homepage" },
        { title: "About Us", path: "/about", description: "Learn about our company" },
        { title: "All Services", path: "/services", description: "View all our services" },
        { title: "Contact Us", path: "/contact", description: "Get in touch with us" },
      ]
    },
    {
      title: "Apostille Services",
      icon: <BiLinkExternal />,
      links: [
        { title: "Apostille Online", path: "/apostille-online", description: "Apply for apostille online" },
        { title: "Apostille", path: "/apostille", description: "Complete apostille guide" },
        { title: "Personal Document Apostille", path: "/services/personal", description: "Personal documents attestation" },
        { title: "Commercial Document Apostille", path: "/services/commercial", description: "Commercial documents attestation" },
        { title: "Apostille Service in Mumbai", path: "/services/apostillemumbai", description: "Apostille services in Mumbai" },
      ]
    },
    {
      title: "Resources & Information",
      icon: <MdOutlineLink />,
      links: [
        { title: "All Resources", path: "/resources", description: "Access all resources" },
        { title: "Document Apostille", path: "/apostille", description: "Document apostille process" },
        // { title: "Hague Apostille Country List", path: "/resources/hague-list", description: "List of Hague Convention countries" },
        // { title: "MEA Approved University List", path: "/mea-approved-university-list", description: "Universities approved by MEA" },
      ]
    },
    {
      title: "Blog & FAQs",
      icon: <FaLink />,
      links: [
        { title: "All Blogs", path: "/blog", description: "Read our latest articles" },
        { title: "Apostille Attestation", path: "/apostille", description: "Guide to apostille attestation" },
        // { title: "GK Scholarship", path: "/blog/gksscholarship", description: "GK scholarship information" },
        { title: "FAQs", path: "/faq", description: "Frequently asked questions" },
      ]
    },
    {
      title: "Quick Links",
      icon: <FaExternalLinkAlt />,
      links: [
        { title: "Useful Links", path: "/useful-links", description: "All useful links" },
      ]
    }
  ];

  const heroStyle = {
    backgroundImage: `url(${heroBg})`,
  };

  return (
    <div className="useful-page">

      {/* HERO SECTION */}
      <section className="useful-hero-section" style={heroStyle}>
        <div className="useful-hero-overlay" />
        <div className="useful-hero-inner">
          <div className="useful-hero-content">
            <h1 className="useful-hero-title">Useful Links</h1>
            <nav className="useful-hero-breadcrumb">
              <ul>
                <li><Link to="/">Home</Link></li>
                <li className="useful-crumb-sep"><FaAngleRight /></li>
                <li className="useful-crumb-current">Useful Links</li>
              </ul>
            </nav>
          </div>
        </div>
      </section>

      {/* INTRODUCTION */}
      <section className="useful-intro-section">
        <div className="useful-container">
          <div className="useful-intro-content">
            <span className="useful-section-small-title">QUICK ACCESS</span>
            <h2 className="useful-section-main-title">All Important Links at One Place</h2>
            <p className="useful-intro-description">
              Navigate through our website easily with this comprehensive collection of all important pages. 
              Whether you're looking for specific services, resources, or information, you'll find it here.
            </p>
          </div>
        </div>
      </section>

      {/* LINKS GRID */}
      <section className="useful-links-grid-section">
        <div className="useful-container">
          <div className="useful-categories-grid">
            {linkCategories.map((category, idx) => (
              <div className="useful-category-wrapper" key={idx}>
                <div className="useful-category-header">
                  <span className="useful-category-icon">{category.icon}</span>
                  <h3>{category.title}</h3>
                </div>
                <div className="useful-category-links">
                  {category.links.map((link, linkIdx) => (
                    <Link to={link.path} className="useful-premium-link" key={linkIdx}>
                      <div className="useful-link-content">
                        <span className="useful-link-title">{link.title}</span>
                        {link.description && (
                          <span className="useful-link-description">{link.description}</span>
                        )}
                      </div>
                      <FaArrowRight className="useful-link-arrow" />
                    </Link>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FEATURED LINKS - Highlighted Section */}
      {/* <section className="useful-featured-section">
        <div className="useful-container">
          <div className="useful-featured-grid">
            <div className="useful-featured-card">
              <div className="useful-featured-icon">📄</div>
              <h4>Document Apostille</h4>
              <p>Complete guide to document apostille process</p>
              <Link to="/apostille" className="useful-featured-link">
                Learn More <FaArrowRight />
              </Link>
            </div>
            <div className="useful-featured-card">
              <div className="useful-featured-icon">🌍</div>
              <h4>Hague Country List</h4>
              <p>All countries accepting apostille</p>
              <Link to="/resources/hague-list" className="useful-featured-link">
                Learn More <FaArrowRight />
              </Link>
            </div>
            <div className="useful-featured-card">
              <div className="useful-featured-icon">🎓</div>
              <h4>MEA Approved Universities</h4>
              <p>List of universities approved by MEA</p>
              <Link to="/mea-approved-university-list" className="useful-featured-link">
                Learn More <FaArrowRight />
              </Link>
            </div>
          </div>
        </div>
      </section> */}

      {/* CTA SECTION */}
      <section className="useful-cta-section">
        <div className="useful-container">
          <h2 className="useful-cta-title">Can't Find What You're Looking For?</h2>
          <p className="useful-cta-description">Our team is here to help you with any questions or specific requirements</p>
          <div className="useful-cta-buttons">
            <Link to="/contact" className="useful-btn-primary">Contact Us</Link>
            <Link to="/faq" className="useful-btn-secondary">Visit FAQ</Link>
          </div>
        </div>
      </section>

    </div>
  );
}